import React, { createContext } from "react";
const StateContext = createContext({});
const LineDataContext = createContext({});
const SetContext = createContext({});

export { StateContext, LineDataContext, SetContext };